export default "__VITE_ASSET__bYNGqYJK__"